import { colors } from "components/Theme/WebTheme";
import {SECONDORY_COLOR,FONT_FAMILY} from "../../common/sharedFunctions"
const TableStyle = () => {
    return {
        editable: {
            backgroundColor: colors.Header_Text,
            fontSize: "0.8em",
            fontWeight: "bold ",
            fontFamily: FONT_FAMILY 
          },
          pageSize: 20,
          pageSizeOptions: [10, 20, 50, 100],
          padding: "dense",
          headerStyle: {
            color: colors.Black,
            position: "sticky",
            top: "0px",
            backgroundColor:SECONDORY_COLOR,
            textAlign: "center",
            fontSize: "0.8em",
            fontWeight: "bold ",
            border: `1px solid ${colors.TABLE_BORDER}`,
            fontFamily: FONT_FAMILY,
            padding: "8px 6px",
          },
          cellStyle: {
            border: `1px solid ${colors.TABLE_BORDER}`,
            textAlign: "center",
            padding: "6px 6px",
          },
          actionsColumnIndex: -1,
        }
};

export default TableStyle;